export enum FormMode {
    Create,
    Edit,
    Reset,
}
